export default function formatSqlDateIntoJsDate(mysqlDate) {
  return new Date(mysqlDate.replace(/-/g, "/").replace(/T.+/, ""));
}
